import React, { useState, useEffect } from "react"
import { Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../Shared/ErrorPopUp'
import FormikCheckbox from '../Shared/FormikCheckbox'
import GenderSelect from '../Shared/GenderSelect'
import CustomerTypeSelect from '../Shared/CustomerTypeSelect'
import CustomerSubTypeSelect from '../Shared/CustomerSubTypeSelect'
import DateInput from '../Shared/DateInput'
import DigitInput from '../Shared/DigitInput'
import BrandsMultiSelect from '../Shared/BrandsMultiSelect'

export default (props) => {
  const { touched, errors, setFieldValue, values, handleBlur } = props;
  return (
    <div className="row display-flex">
      <div className="col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-12 col-xs-12">

        <div className="row">
          <div className="form-inline">

            <div className="col-lg-6 col-sm-12">
              <label>عنوان تفصیلی</label>
              <Field type="text"

                name="title"
                className={getIn(touched, "title") ? getIn(errors, "title") ? "text-input has-error" : "text-input" : "text-input has-error"}
              />
              <ErrorMessage component={ErrorPopUp} name="title" />
            </div>

            <div className="clearfix form-row"></div>

            <div className={values.customerTypeIsLegal ? "col-lg-2 col-sm-12" : "col-lg-4 col-sm-12"}>
              <label>نوع مشتری</label>
              <CustomerTypeSelect name="customerType" value={values.customerType} defaultValue={values.customerType}
                onChange={(val) => {
                  if (val === 0) {
                    setFieldValue('customerTypeIsLegal', false)
                    setFieldValue('customerSubType', undefined)
                  } else {
                    setFieldValue('customerTypeIsLegal', true)
                  }
                  setFieldValue('customerType', val)
                }}
              />
              <ErrorPopUp error={errors.customerType} touched={touched.customerType} type="select" />
            </div>

            {values.customerTypeIsLegal &&
              (<div className="col-lg-2 col-sm-12">
                <label>نوع فرعی</label>
                <CustomerSubTypeSelect name="customerSubType" value={values.customerSubType} defaultValue={values.customerSubType}
                  onChange={(val) => {
                    setFieldValue('customerSubType', val)
                  }}
                />
                <ErrorMessage component={ErrorPopUp} name="customerSubType" type="select" />
                {/* <ErrorPopUp error={errors.customerSubType} touched={touched.customerSubType} type="select" /> */}
              </div>)
            }

            <div className="col-lg-2 col-sm-12">
              <label>جنسیت</label>
              <GenderSelect name="gender" value={values.gender} defaultValue={values.gender}
                onChange={(val) => {
                  setFieldValue('gender', val);
                }}

              />
              <ErrorPopUp error={errors.gender} touched={touched.gender} type="select" />
            </div>

            <div className="col-lg-3 col-sm-12">
              <label>نام</label>
              <Field type="text"

                name="firstName"
                className={getIn(touched, "firstName") ? getIn(errors, "firstName") ? "text-input has-error" : "text-input" : "text-input has-error"}
              />
              <ErrorMessage component={ErrorPopUp} name="firstName" />
            </div>

            <div className="col-lg-3 col-sm-12">
              <label>نام خانوادگی</label>
              <Field type="text"

                name="lastName"
                className={getIn(touched, "lastName") ? getIn(errors, "lastName") ? "text-input has-error" : "text-input" : "text-input has-error"}
              />
              <ErrorMessage component={ErrorPopUp} name="lastName" />
            </div>

            <div className="clearfix form-row"></div>

            <div className="col-lg-3 col-sm-12">
              <label>تلفن همراه</label>
              <Field type="text"

                name="mobile"
                className={getIn(touched, "mobile") ? getIn(errors, "mobile") ? "text-input has-error" : "text-input" : "text-input has-error"}
              />
              <ErrorPopUp error={errors.mobile} touched={touched.mobile} type="fullText" />
            </div>

            <div className="col-lg-3 col-sm-12">
              <label>ایمیل</label>
              <Field type="text"

                name="email"
                className={getIn(touched, "email") ? getIn(errors, "email") ? "text-input has-error" : "text-input" : "text-input has-error"}
              />
              <ErrorMessage component={ErrorPopUp} name="email" />
            </div>

            <DigitInput label="کد ملی" fieldName="nationalCode" error={errors.nationalCode} maxLength={10} {...props} />

            <div className="col-lg-3 col-sm-12">
              <label>تاریخ تولد</label>
              <DateInput
                defaultValue={values && values.dateOfBirth}
                className="text-input"
                onChange={dateOfBirth => {
                  setFieldValue('dateOfBirth', dateOfBirth);
                }}
                className={getIn(touched, "dateOfBirth") ? getIn(errors, "dateOfBirth") ? "text-input has-error" : "text-input" : "text-input has-error"}
              />
            </div>

            <div className="clearfix form-row"></div>

            <div className="col-lg-3 col-sm-12">
              <label>کد اقتصادی</label>
              <Field type="text"

                name="economicCode"
                className={getIn(touched, "economicCode") ? getIn(errors, "economicCode") ? "text-input has-error" : "text-input" : "text-input has-error"}
              />
              <ErrorMessage component={ErrorPopUp} name="economicCode" />
            </div>

            <div className="col-lg-3 col-sm-12">
              <label>شماره ثبت</label>
              <Field type="text"

                name="registrationNumber"
                className={getIn(touched, "registrationNumber") ? getIn(errors, "registrationNumber") ? "text-input has-error" : "text-input" : "text-input has-error"}
              />
              <ErrorMessage component={ErrorPopUp} name="registrationNumber" />
            </div>

            <div className="col-lg-6 col-sm-12">
              <label>&nbsp;</label>
              <Field
                component={FormikCheckbox}
                name="sendSms"
                id="sendSms"
                label={"ارسال گزارشات پیشرفت سفارشهای مشتری از طریق پیامک"}
              />
            </div>

            <div className="clearfix form-row"></div>

            <div className="col-lg-6 col-sm-12">
              <label>برندها</label>
              <BrandsMultiSelect
                brandType={1}
                value={values.brands}
                onChange={val => {
                  setFieldValue("brands", val)
                }}
                className={errors.brands ? "select is-invalid" : "select"}
              />
              <ErrorMessage component={ErrorPopUp} name="brands" />
            </div>

          </div>
        </div>

      </div>

    </div>
  )
}